<template>
  <div class="user-management">
    <div class="top">
      <SimpleTable
        ref="topTable"
        table-code="userManagementTop"
        :menus="['查询', '批量修改', '插入', '批量删除']"
        :columns="columns.top"
        :data="tableData.top"
        :loading="loading.top"
        @row-select="onRowSelectTop"
        @modify-data-change="onModifyDataChangeTop"
      />
    </div>
    <LeftRightBox :leftWidthDefault="1000" height="50%">
      <template slot="left">
        <SimpleTable
          ref="leftTable"
          table-code="userManagementLeft"
          :menus="['查询', '批量修改', '插入', '批量删除']"
          :columns="columns.left"
          :data="tableData.left"
          :loading="loading.left"
          @row-select="onRowSelectLeft"
          @modify-data-change="onModifyDataChangeLeft"
        />
      </template>
      <template slot="right">
        <SimpleTable
          ref="rightTable"
          table-code="userManagementRight"
          :menus="['查询', '批量修改', '插入', '批量删除']"
          :columns="columns.right"
          :data="tableData.right"
          :loading="loading.right"
          @modify-data-change="onModifyDataChangeRight"
        />
      </template>
    </LeftRightBox>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import { sortRecords, addCbFn, getOptions } from '@/utils/index'

export default {
  name: 'UserManagement',
  components: {
    SimpleTable,
    LeftRightBox
  },
  data() {
    return {
      // 页面数据
      columns: {
        top: [
          { field: 'name', title: '单位名称', canEdit: true, canModify: true },
          {
            field: 'type',
            title: '单位类型',
            canEdit: true,
            canModify: true,
            ...getOptions({
              title: '单位类型',
              key: 'type',
              options: [
                { name: '项目甲方' },
                { name: '设计单位' },
                { name: '造价咨询' },
                { name: '施工总包' },
                { name: '专业分包' },
                { name: '材料供应' }
              ]
            })
          },
          {
            field: 'contactorPhone',
            title: '联系人电话',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          },
          {
            field: 'contactorWx',
            title: '联系人微信',
            canEdit: true,
            canModify: true
          },
          {
            field: 'inviterPhone',
            title: '推荐人电话',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          },
          {
            field: 'inviterWx',
            title: '推荐人微信',
            canEdit: true,
            canModify: true
          },
          {
            field: 'regionName',
            title: '所在地区',
            editModal: {
              columns: [{ field: 'name', title: '所在地区' }],
              options: async () => {
                const res = await this.$serviceAdmin.get('/region/list', {})
                return sortRecords(res?.data || [])
              },
              confirm: (selectedCellInfos, res) => {
                const row = res[0][0].originData
                selectedCellInfos.forEach(cells => {
                  const obj = cells[0].originData
                  this.$set(obj, 'regionName', row.name)
                  this.$set(obj, 'regionId', row.id)
                })
              }
            },
            canModify: true
          },
          {
            field: 'ipAddress',
            title: 'IP地址',
            canEdit: true,
            canModify: true
          },
          {
            field: 'adminLockNumber',
            title: '管理员锁号',
            canEdit: true,
            canModify: true
          },
          {
            field: 'expireDate',
            title: '生效日期',
            editor: { type: 'date' },
            canEdit: true,
            canModify: true
          },
          {
            field: 'effectiveDate',
            title: '失效日期',
            editor: { type: 'date' },
            canEdit: true,
            canModify: true
          }
        ],
        left: [
          {
            field: 'lockNumber',
            title: '加密锁编号',
            canEdit: true,
            canModify: true
          },
          {
            field: 'contactorPhone',
            title: '联系人电话',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          },
          {
            field: 'contactorWx',
            title: '联系人微信',
            canEdit: true,
            canModify: true
          },
          {
            field: 'inviterPhone',
            title: '推荐人电话',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          },
          {
            field: 'inviterWx',
            title: '推荐人微信',
            canEdit: true,
            canModify: true
          }
        ],
        right: [
          {
            field: 'menuName',
            title: '功能模块',
            canModify: true,
            ...getOptions(
              {
                title: '功能模块',
                key: 'menuName',
                options: () => this.getOptionsMenus(),
                confirm: (selectedCellInfos, res) => {
                  const row = res[0][0].originData
                  selectedCellInfos.forEach(cells => {
                    const obj = cells[0].originData
                    this.$set(obj, 'menuName', row.name)
                    this.$set(obj, 'menuId', row.id)
                  })
                }
              },
              false
            )
          },
          {
            field: 'status',
            title: '使用状态',
            canEdit: true,
            canModify: true,
            ...getOptions({
              title: '价格类型',
              key: 'status',
              options: [{ name: '试用' }, { name: '运行' }]
            })
          },
          {
            field: 'effectiveDate',
            title: '生效日期',
            editor: { type: 'date' },
            canEdit: true,
            canModify: true
          },
          {
            field: 'expireDate',
            title: '失效日期',
            editor: { type: 'date' },
            canEdit: true,
            canModify: true
          },
          {
            field: 'saleAmount',
            title: '成交金额',
            fieldType: 'number',
            canEdit: true,
            canModify: true
          }
        ]
      },
      curentSelect: {
        top: null,
        left: null,
        right: null
      },
      tableData: {
        top: [],
        left: [],
        right: []
      },
      loading: {
        top: false,
        left: false,
        right: false
      },
      menus: []
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    init() {
      this.getMenus()
      this.getTableTop()
    },
    async getMenus() {
      const res = await this.$serviceAdmin.get('/sys/unit/list', {
        type: 1
      })
      this.menus = sortRecords(res?.data || [])
    },
    getOptionsMenus() {
      return this.menus
    },
    async getTableTop() {
      this.tableData.top = []
      this.loading.top = true
      const res = await this.$serviceAdmin.get('/sys/unit/list', {})
      this.loading.top = false
      this.tableData.top = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.topTable.initialized()
    },
    async getTableLeft(obj = {}) {
      this.tableData.left = []
      this.loading.left = true
      const res = await this.$serviceAdmin.get('/sys/unit/lock/list', {
        unitId: obj.id
      })
      this.loading.left = false
      this.tableData.left = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.leftTable.initialized()
    },
    async getTableRight(obj = {}) {
      this.tableData.right = []
      this.loading.right = true
      const res = await this.$serviceAdmin.get('/sys/unit/lock/menu/list', {
        unitId: obj.unitId,
        unitLockId: obj.id
      })
      this.loading.right = false
      this.tableData.right = sortRecords(res?.data || [])
    },

    onRowSelectTop(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.curentSelect.top = obj
      this.getTableLeft(obj)
    },
    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.curentSelect.left = obj
      this.getTableRight(obj)
    },

    onModifyDataChangeTop(getModifyData, cleanModifyData) {
      addCbFn(
        this.$serviceAdmin,
        '/sys/unit/batch',
        getModifyData,
        cleanModifyData
      )
    },
    onModifyDataChangeLeft(getModifyData, cleanModifyData) {
      addCbFn(
        this.$serviceAdmin,
        '/sys/unit/lock/batch',
        getModifyData,
        cleanModifyData,
        arr => arr.map(e => ({ ...e, unitId: this.curentSelect.top.id }))
      )
    },
    onModifyDataChangeRight(getModifyData, cleanModifyData) {
      addCbFn(
        this.$serviceAdmin,
        '/sys/unit/lock/menu/batch',
        getModifyData,
        cleanModifyData,
        arr =>
          arr.map(e => ({
            ...e,
            menuParentId: -1,
            unitId: this.curentSelect.top.id,
            unitLockId: this.curentSelect.left.id
          }))
      )
    }
  }
}
</script>

<style scoped>
.user-management {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
  .top {
    height: 400px;
    width: 100%;
  }
}
</style>
